const getReactOnChange = (inputElement) => {
  const propsKey = Object.keys(inputElement).find(
    (key) => key.startsWith('__reactProps') || key.startsWith('__reactEventHandlers')
  );

  if (propsKey && typeof inputElement[propsKey]?.onChange === 'function') {
    return inputElement[propsKey].onChange;
  }

  return null;
};

const setNativeInputValue = (inputElement, value) => {
  const prototype =
    inputElement instanceof HTMLTextAreaElement
      ? HTMLTextAreaElement.prototype
      : HTMLInputElement.prototype;

  const valueSetter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;

  if (valueSetter) {
    valueSetter.call(inputElement, value);
  } else {
    inputElement.value = value;
  }
};

export const syncInputElementValue = (inputElement, value) => {
  if (!inputElement || value === undefined || value === null) {
    return;
  }

  setNativeInputValue(inputElement, value);

  const onChange = getReactOnChange(inputElement);
  if (onChange) {
    onChange({
      target: {
        value,
        name: inputElement.name,
        type: inputElement.type,
        id: inputElement.id,
      },
      currentTarget: inputElement,
      preventDefault: () => {},
      stopPropagation: () => {},
      persist: () => {},
    });
    return;
  }

  inputElement.dispatchEvent(
    new InputEvent('input', { bubbles: true, inputType: 'insertReplacementText', data: value })
  );
  inputElement.dispatchEvent(new Event('change', { bubbles: true }));
};
